import React from "react"
import { Header, Container, Segment, Grid, Button } from "semantic-ui-react"
import { observer } from "mobx-react"
import categoryStore from "stores/categoryStore"
import { confirmOrderModeChange, applyOrderMode } from "../shop/orderMode"

@observer
class CategoryList extends React.Component {
  
  render() {
    const { categories } = categoryStore
    return <div>
      {categories.map( category => {
        return <div key={category.map_id}>{category.title}</div>
      } )}
    </div>
  }
}

export default class SofortOrderPage extends React.Component {
  
  setStoreMode = ( e, mode ) => {
    confirmOrderModeChange( mode )
      .then( confirmed => {
        if ( confirmed ) this.continue( mode )
      } )
  }
  
  continue( mode ) {
    applyOrderMode( mode )
    this.props.history.replace( "/" )
  }
  
  render() {
    return <div className="bg-silver min-vh-100">
      <div className="flex flex-column justify-center min-vh-100">
        <Container text className={"pt4"}>
          <Grid columns={2}  stackable >
            <Grid.Row>
              <Grid.Column>
                <Segment className={"tc"}>
                  <Header as={"h3"}>{translate( "MODE_AVAILABLE" )}</Header>
                  <div className={"pb3"}>
                    {translate( "sofort_notice" )}
                  </div>
                </Segment>
                <div className="tc"><Button onClick={( e ) => this.setStoreMode( e, "MODE_AVAILABLE" )} primary>{translate( "Weiter" )}</Button></div>
              </Grid.Column>
              
              <Grid.Column>
                <Segment className={"tc"}>
                  <Header as={"h3"}>{translate( "MODE_PREORDER" )}</Header>
                  <div className={"pb3"}>
                    <p>{translate( "preorder_notice" )}</p>
                  </div>
                </Segment>
                <div className="tc"><Button onClick={( e ) => this.setStoreMode( e, "MODE_PREORDER" )} primary>{translate( "Weiter" )}</Button></div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/theme/arnoldsports/pages/SofortOrderPage.js